import {
    Component,
    DestroyRef,
    effect,
    inject,
    input,
    signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { TranslatedString } from 'lemunzo-api';
import { resolveTranslatedString } from '../../utils/resolve-translated-string';
import { RichTextRendererComponent } from '../rich-text-renderer/rich-text-renderer.component';

@Component({
    selector: 'apcam-translation-rich-text',
    imports: [RichTextRendererComponent],
    templateUrl: './translation-rich-text.component.html',
    styleUrl: './translation-rich-text.component.scss',
})
export class TranslationRichTextComponent {
    private readonly destroyRef = inject(DestroyRef);
    private readonly translateService = inject(TranslateService);

    readonly model = input<TranslatedString | undefined>();
    readonly class = input<string | undefined>();

    protected readonly resolvedHtml = signal<string | null>(null);

    constructor() {
        effect(() => {
            this.model();
            this.resolve();
        });

        this.translateService.onLangChange
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({ next: () => this.resolve() });
    }

    private resolve(): void {
        this.resolvedHtml.set(
            resolveTranslatedString(this.model(), this.translateService)
        );
    }
}
